import React, {useContext} from 'react';
import {ReportsContext} from '../context/ReportsProvider';
import ReportsHeader from '../components/ReportsHeader';
import {Row, Container} from 'react-bootstrap';
import DoughnutChart from '../../components/UI/Reports/DoughnutChart/DoughnutChart';
import BarAndLineChart from '../../components/UI/Reports/MixedChart/BarAndLineChart';
import { LanguageContext } from "../../containers/Language/LanguageProvider";
import './index.css';

function ReportsChartContainer(props) {
    const languageContext = useContext(LanguageContext);
    const { reportDetails } = useContext(ReportsContext); 
    const title = languageContext && languageContext.labels && languageContext.labels["used_by_myconcessions"] ? languageContext.labels["used_by_myconcessions"] : "";
    const fixed = languageContext && languageContext.labels && languageContext.labels["fixed"] ? languageContext.labels["fixed"] : "";
    const variable = languageContext && languageContext.labels && languageContext.labels["variable"] ? languageContext.labels["variable"] : "";
    const usePerQtrTitle = languageContext && languageContext.labels && languageContext.labels["use_per_qtr_title"] ? languageContext.labels["use_per_qtr_title"] : "";
    const revenuePerQtrTitle = languageContext && languageContext.labels && languageContext.labels["revenue_per_qtr_title"] ? languageContext.labels["revenue_per_qtr_title"] : "";
    const fixed_contract = languageContext && languageContext.labels && languageContext.labels["fixed_contract"] ? languageContext.labels["fixed_contract"] : "";
    const variable_contract = languageContext && languageContext.labels && languageContext.labels["variable_contract"] ? languageContext.labels["variable_contract"] : "";
    const fixed_total_revenue = languageContext && languageContext.labels && languageContext.labels["fixed_total_revenue"] ? languageContext.labels["fixed_total_revenue"] : "";
    const variable_total_revenue = languageContext && languageContext.labels && languageContext.labels["variable_total_revenue"] ? languageContext.labels["variable_total_revenue"] : "";

    const [chartKey, setChartKey]= React.useState(1);
    
    React.useEffect(()=> {
     window.onresize=()=>setChartKey(chartKey+1);   
    }, []); 

    return (
          <>
              <Container className="reporting-container">  
                  <Row className="container-row">
                      <ReportsHeader />
                  </Row>
                  <Row className="container-row">                     
                      <div className="container-left">
                          {title && reportDetails && <div className="chart-title">{title}</div>}
                          <div>
                            {
                                reportDetails && reportDetails.variableContracts !== undefined && 
                                reportDetails.variableContracts !== null
                                ? <DoughnutChart key={chartKey} title={variable} innerColor="#BFDAEC" 
                                    reportDetails = {reportDetails.variableContracts}/> 
                                : null 
                            }
                          </div>
                          <div style={{textAlign: "center"}}>
                                <div className="variable-donut-title-box">&nbsp;</div>
                                <div className="donut-title">&nbsp;{variable}</div>
                          </div>
                          <div>
                             {reportDetails && reportDetails.fixedContracts !== undefined && reportDetails.fixedContracts !== null
                               ? <DoughnutChart key={chartKey} title={fixed} innerColor="#F2D227" reportDetails = {reportDetails.fixedContracts}/> : null }
                          </div>
                          <div style={{textAlign: "center"}}>
                                <div className="fix-donut-title-box">&nbsp;</div>
                                <div className="donut-title">&nbsp;{fixed}</div>
                          </div>
                      </div>   
                      {reportDetails && reportDetails.qoqReport && <>
                      <div className="container-right">
                            <div>
                                <BarAndLineChart key={chartKey+"1"} 
                                    qoqReport={reportDetails.qoqReport}
                                    fixedColor="#3A6073"
                                    variableColor="rgb(54, 162, 235)"
                                    borderColor="rgb(255, 99, 132)"
                                    pointColor="#BFDAEC"
                                    usePerQtrTitle={usePerQtrTitle}
                                    revenuePerQtrTitle={revenuePerQtrTitle}
                                    />
                            </div>
                            <div key={chartKey+"2"}>
                                <div className="title-container-left">&nbsp;</div>
                                <div className="title-container-right  top-legend">
                                    <div className="legend-container">
                                        &nbsp;<div className="fix-chart-title-box">&nbsp;</div>&nbsp;
                                        <div className="mixed-chart-title">&nbsp;{fixed_contract}</div>
                                        &nbsp;<div className="variable-chart-title-box">&nbsp;</div>&nbsp;
                                        <div className="mixed-chart-title">&nbsp;&nbsp;{variable_contract}</div>
                                    </div>
                                </div>
                            </div>
                            <div key={chartKey+"3"}>
                                <div className="title-container-left">&nbsp;</div>
                                <div className="title-container-right bottom-legend">
                                    <div className="legend-container">
                                        <div className="legend-title-icon-outer"><div className="fix-chart-title-icon">&nbsp;</div></div>&nbsp;
                                        <div className="mixed-chart-title">{fixed_total_revenue}</div>
                                        <div className="legend-title-icon-outer"><div className="variable-chart-title-icon">&nbsp;</div></div>&nbsp;
                                        <div className="mixed-chart-title">{variable_total_revenue}</div>
                                    </div>
                                </div>
                            </div>
                      </div>
                    </>
                    }                    
                  </Row>
              </Container> 
          </>
      )
}

export default ReportsChartContainer;